// extracted by mini-css-extract-plugin
module.exports = {"product":"H_cx","product__image":"H_cy","product__featured":"H_cz","product__prices":"H_cB","product__prices__sale":"H_cC","product__title":"H_cD","product__title__sale":"H_cF"};